<template>
  <div class="demand-content">
    <a-row>
      <a-col :span="6">
        <p>品牌名称</p>
        <p v-if="userInfo.brandName" class="bold">{{ userInfo.brandName }}</p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col :span="6">
        <p>区域</p>
        <p v-if="userInfo.districtName" class="bold">{{ userInfo.districtName }}</p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col
        :span="6"
      ><p>商圈</p>
        <p class="bold" v-if="userInfo.businessDistrictName">{{ userInfo.businessDistrictName }}</p>
        <p v-else class="bold">-</p></a-col
      >

      <a-col
        :span="6"
      ><p>街道</p>
        <p class="bold" v-if="userInfo.streetName">{{ userInfo.streetName }}</p>
        <p v-else class="bold">-</p>
      </a-col>
    </a-row>
    <a-row style="margin-top: 10px">
      <a-col :span="6">
        <p>面积</p>
        <p v-if="userInfo.requirementAreaStart && userInfo.requirementAreaEnd" class="bold">
          {{ userInfo.requirementAreaStart }} m²- {{ userInfo.requirementAreaEnd }}m²
        </p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col :span="6">
        <p>行业</p>
        <p v-if="userInfo.industryCategoryName" class="bold">
          {{ userInfo.industryCategoryName
          }}{{ userInfo.industrySubclassName ? '-' + userInfo.industrySubclassName : '' }}
        </p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col
        :span="6"
      ><p>楼层</p>
        <p v-if="userInfo.floorStart" class="bold">{{ userInfo.floorStart }}-{{ userInfo.floorEnd }}</p>
        <p v-else class="bold">-</p>
      </a-col>
      <!-- <a-col :span="6"
        ><p>是否临街</p>
        <p class="bold">{{ userInfo.isFrontage === 'Y' ? '是' : '否' }}</p>
      </a-col> -->
      <a-col :span="6">
        <p>租金</p>
        <p v-if="userInfo.rentExpenseStart" class="bold">
          {{ userInfo.rentExpenseStart ? userInfo.rentExpenseStart :'-' }} ~ {{ userInfo.rentExpenseEnd ? userInfo.rentExpenseEnd : '-' }}元/月
          <!-- ，{{ priceMonth }}元/m²/月，{{ priceDay }}元/m²/天 -->
        </p>
        <p v-else class="bold">-</p>
      </a-col>
    </a-row>
    <a-row style="margin-top: 10px">
      <!-- 隐藏是否餐饮 -->
      <!-- <a-col :span="6">
        <p>是否餐饮</p>
        <p class="bold">{{ userInfo.isCatering === 'Y' ? '是' : '否' }}</p>
      </a-col> -->
      <a-col :span="6">
        <p>是否接受转让费</p>
        <p v-if="userInfo.isHaveTransferFee" class="bold">{{ userInfo.isHaveTransferFee === 'Y' ? '是' : '否' }}</p>
        <p v-else class="bold">-</p>
      </a-col>
      <!-- <a-col :span="6"
        ><p>支付方式</p>
        <p v-if="111" class="bold">-</p>
        <p v-else class="bold">-</p>
      </a-col> -->
      <!-- <a-col :span="6"
        ><p>客流人群</p>

        <p class="bold">
          {{ userInfo.trafficCrowd ? userInfo.trafficCrowd : '-' }}
        </p>
      </a-col> -->
    </a-row>
    <a-row style="margin-top: 10px">
      <!-- <a-col :span="6">
        <p>递增</p>
        <p class="bold" v-if="111">-</p>
      </a-col> -->
      <!-- <a-col :span="6"
        ><p>佣金</p>
        <p v-if="111" class="bold">-</p>
        <p v-else class="bold">-</p>
      </a-col> -->
      <!-- <a-col :span="6"
        ><p>相关费用</p>
        <p v-if="111" class="bold">-</p>
        <p v-else class="bold">-</p>
      </a-col> -->
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object,
      require: true
    }
  },
  data () {
    return {}
  },
  methods: {},
  computed: {
    rentExpenseStart () {
      return (Number(this.userInfo.rentExpenseStart) / 10000).toFixed(2)
    },
    priceMonth () {
      return (
        Number(this.userInfo.rentExpenseStart) /
        Number(this.userInfo.requirementAreaStart > 0 ? this.userInfo.requirementAreaStart : 1)
      ).toFixed(2)
    },
    priceDay () {
      return (
        Number(this.userInfo.rentExpenseStart) /
        Number(this.userInfo.requirementAreaStart > 0 ? this.userInfo.requirementAreaStart : 1) /
        30
      ).toFixed(2)
    }
  },
  created () {}
}
</script>

<style lang="less" scoped>
.demand-content {
  padding: 10px;
  p {
    margin-bottom: 8px;
  }
  .bold {
    font-weight: bold;
    color: #000;
    font-size: 14px;
  }
}
</style>
